module.exports = new __parcel__URL__("super_swole_squad_department_level_2.d9a4de50.png").toString();